(ns ballot-scout-v2-frontend.core
  (:require
   [ballot-scout-v2-frontend.auth :as auth]
   [ballot-scout-v2-frontend.config :as config]
   [ballot-scout-v2-frontend.events :as events]
   [ballot-scout-v2-frontend.routes :as routes]
   [ballot-scout-v2-frontend.views :as views]
   [re-frame.core :as rf]
   [reagent.dom :as dom]))

(defn dev-setup []
  (when config/debug?
    (enable-console-print!)
    (println "dev mode")))

(defn ^:dev/after-load mount-root []
  (rf/clear-subscription-cache!)
  (dom/render [views/main-panel]
              (.getElementById js/document "ballot-scout")))

(defn launch! []
  (routes/app-routes)
  (dev-setup)
  (mount-root))

(defn init []
  (rf/dispatch-sync [::events/initialize-db])
  (rf/dispatch-sync [::auth/fetch-user-profile-if-needed-or-require-login launch!]))
